import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListResultDTO } from 'src/app/helpers/listResult.interface';
import { environment } from 'src/environments/environment';
import { RiskAreaDTO, RiskAreaFilters } from '../../models/risk-area.model';

@Injectable({
  providedIn: "root"
})
export class LaravelRiskAreaService {


  constructor(private httpClient: HttpClient) { }

  private get ROUTES() {
    return {
 
      list: environment.baseUrl + "/api/risk_areas",
      show: environment.baseUrl + "/api/risk_area",
      store: environment.baseUrl + "/api/risk_area",
      destroy: environment.baseUrl + "/api/risk_area",
  
    };
  }

  public list(page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: RiskAreaFilters,
    includes?: string[]
  ): Observable<ListResultDTO<RiskAreaDTO>> {
    let params = {};
    if (order) params["order"] = "" + order;
    if (direction) params["direction"] = "" + direction;
    if (includes) params["includes[]"] = includes;
    if (filters) {
      if (filters.search) params["search"] = "" + filters.search;
  }
    if (per_page) {
      params["per_page"] = "" + per_page;
      if (page) params["page"] = "" + page;
      return this.httpClient.get<ListResultDTO<RiskAreaDTO>>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      });
    } else {
      return this.httpClient.get<RiskAreaDTO[]>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      }).pipe(
        map(results => {
          return {
            data: results,
            total: results.length
          };
        })
      );
    }
  }


  public getRiskAreaById(id: number): Observable<RiskAreaDTO> {
    let params = { id: "" + id };
    return this.httpClient.get<RiskAreaDTO>(this.ROUTES.show, {
      params: new HttpParams({
        fromObject: params
      })
    });

  }

  public upsert(risk_area: RiskAreaDTO): Observable<RiskAreaDTO> {
    if (risk_area.id) {
      return this.httpClient.put<RiskAreaDTO>(`${this.ROUTES.store}`, { risk_area });
    } else {
      return this.httpClient.post<RiskAreaDTO>(`${this.ROUTES.store}`, { risk_area });
    }
  }

  public delete(id: number): Observable<any> {
    let params = { id: "" + id };
    return this.httpClient.delete(this.ROUTES.destroy, {
      params: new HttpParams({
        fromObject: params
      })
    });
  }
}
